import { buildActionCreator, createReducer } from '../../../createReducerHelper';
import { FORM_VALIDATION_ERROR_MESSAGE } from '../FormContent/enums/formEnums';

const PREFIX = 'MLB_FORM';
export const FORM_FETCH = 'FETCH/FORM/RESULTS';
const FORM_FETCH_SUCCESS = 'FETCH/FORM/SUCCESS_FETCHED';
const RESPONSE_ERROR = 'FETCH/FORM/FETCH_ERROR';
const FORM_VALIDATION_ERROR = 'FORM/VALIDATION_ERROR';

export function validationErrorAction() {
  return {
    type: FORM_VALIDATION_ERROR,
    payload: FORM_VALIDATION_ERROR_MESSAGE,
  };
}
export function fetchFormResultsAction(fieldValues) {
  return {
    type: FORM_FETCH,
    payload: fieldValues,
  };
}
export function successFetchedResultsAction(policies) {
  return {
    type: FORM_FETCH_SUCCESS,
    payload: policies,
  };
}
export function errorResponseAction(errorMessage) {
  return {
    type: RESPONSE_ERROR,
    payload: errorMessage,
  };
}

export const triggerMonthlyPaymentInfoAction = buildActionCreator(`${PREFIX}/INFO/MONTHLY_PAYMENT`);
export const triggerDisabilityAssessmentInfoAction = buildActionCreator(`${PREFIX}/INFO/DISABILITY_ASSESSMENT`);
export const triggerPaymentPeriodInfoAction = buildActionCreator(`${PREFIX}/INFO/PAYMENT_PERIOD`);
export const triggerDisabilityPeriodInfoAction = buildActionCreator(`${PREFIX}/INFO/DISABILITY_PERIOD`);
export const triggerInsuranceStartDateInfoAction = buildActionCreator(`${PREFIX}/INFO/INSURANCE_START_DATE`);
export const triggerPartlyDisabledInfoAction = buildActionCreator(`${PREFIX}/INFO/PARTLY_DISABLED`);
export const triggerUnemploymentInsuranceInfoAction = buildActionCreator(`${PREFIX}/INFO/UNEMPLOYMENT_INSURANCE`);
export const triggerUnemploymentPeriodInfoAction = buildActionCreator(`${PREFIX}/INFO/UNEMPLOYMENT_PERIOD`);
export const outsideClickAction = buildActionCreator(`${PREFIX}/INFO/OUTSIDE_CLICK`);


const initialState = {
  isValidationError: false,
  isMonthlyPaymentInfoClicked: false,
  isDisabilityAssessmentInfo: false,
  isPaymentPeriodInfo: false,
  isDisabilityPeriodInfo: false,
  isInsuranceEndDateInfo: false,
  isPartlyDisabledInfo: false,
  requestedPolicies: null,
  isUnemploymentPeriodInfo: false,
};

export const mlbSummaryReducer = createReducer(initialState, {
  [validationErrorAction]: (state) => ({
    ...state,
    isValidationError: true,
  }),
  [triggerMonthlyPaymentInfoAction]: (state) => ({
    ...state,
    isMonthlyPaymentInfoClicked: !state.isMonthlyPaymentInfoClicked,
  }),
  [triggerDisabilityAssessmentInfoAction]: (state) => ({
    ...state,
    isDisabilityAssessmentInfo: !state.isDisabilityAssessmentInfo,
  }),
  [triggerPaymentPeriodInfoAction]: (state) => ({
    ...state,
    isPaymentPeriodInfo: !state.isPaymentPeriodInfo,
  }),
  [triggerDisabilityPeriodInfoAction]: (state) => ({
    ...state,
    isDisabilityPeriodInfo: !state.isDisabilityPeriodInfo,
  }),
  [triggerUnemploymentInsuranceInfoAction]: (state) => ({
    ...state,
    isUnemploymentInsuranceInfo: !state.isUnemploymentInsuranceInfo,
  }),
  [triggerUnemploymentPeriodInfoAction]: (state) => ({
    ...state,
    isUnemploymentPeriodInfo: !state.isUnemploymentPeriodInfo,
  }),
  [triggerInsuranceStartDateInfoAction]: (state) => ({
    ...state,
    isInsuranceEndDateInfo: !state.isInsuranceEndDateInfo,
  }),
  [triggerPartlyDisabledInfoAction]: (state) => ({
    ...state,
    isPartlyDisabledInfo: !state.isPartlyDisabledInfo,
  }),
  [outsideClickAction]: (state) => ({
    ...state,
    isMonthlyPaymentInfoClicked: false,
    isDisabilityAssessmentInfo: false,
    isPaymentPeriodInfo: false,
    isDisabilityPeriodInfo: false,
    isInsuranceEndDateInfo: false,
    isPartlyDisabledInfo: false,
    isUnemploymentInsuranceInfo: false,
    isUnemploymentPeriodInfo: false,
  }),
});

const initialFormUserInteractionState = {
  isSelectedUnemploymentRadioValueAsYes: false,
  isLoading: false,
  isFormResult: false,
  isErrorMessage: false,
  errorMessages: [],
};

export const formUserInteractionReducer = (state = initialFormUserInteractionState, action) => {
  switch (action.type) {
    case FORM_FETCH:
      return {
        ...state,
        isLoading: true,
        isErrorMessage: false,
        isFormResult: false,
      };
    case FORM_FETCH_SUCCESS:
      return {
        ...state,
        isFormResult: true,
        isErrorMessage: false,
        isLoading: false,
        requestedPolicies: action.payload,
      };
    case RESPONSE_ERROR:
      return {
        ...state,
        isFormResult: false,
        isErrorMessage: true,
        isLoading: false,
        errorMessages: action.payload,
      };
    case FORM_VALIDATION_ERROR:
      return {
        ...state,
        isFormResult: false,
        isErrorMessage: true,
        errorMessages: action.payload,
      };
    default: return state;
  }
};
